// The screenshots a new user gave step 4 of the first-run wizard, as the
// extension hands them over, turned into files for the chat's upload input.

// Step 4 takes up to four screenshots
export const MAX_ONBOARDING_SCREENSHOTS = 4

/**
 * A wizard screenshot as a file for the upload input, or null when it isn't
 * a PNG or JPEG data URL. Named here rather than by the wizard: the upload
 * accepts by extension, and the extension must match the bytes.
 * @param {string} dataUrl - the screenshot as the extension returned it
 * @param {number} index - its place among the screenshots, for the name
 * @returns {File|null}
 */
export function screenshotFile (dataUrl, index = 0) {
  const matches = typeof dataUrl === 'string'
    ? dataUrl.match(/^data:(image\/(?:png|jpeg));base64,(.+)$/)
    : null
  if (!matches) { return null }

  const mimeType = matches[1]
  let bytes
  try {
    bytes = Uint8Array.from(atob(matches[2]), (c) => c.charCodeAt(0))
  } catch {
    return null
  }
  const extension = mimeType === 'image/png' ? 'png' : 'jpg'
  const suffix = index > 0 ? `-${index + 1}` : ''
  return new File([bytes], `browser-screenshot${suffix}.${extension}`, { type: mimeType })
}

/**
 * The files for the screenshots the extension returned, in order, at most
 * four, leaving out anything that isn't a PNG or JPEG data URL.
 * @param {unknown[]} dataUrls - the screenshots as the extension returned them
 * @returns {File[]}
 */
export function screenshotFiles (dataUrls) {
  return (Array.isArray(dataUrls) ? dataUrls : [])
    .map((dataUrl, index) => screenshotFile(dataUrl, index))
    .filter(Boolean)
    .slice(0, MAX_ONBOARDING_SCREENSHOTS)
}
